(function () {
  'use strict';

  function favourite(SegmentAnalytics, $state, UserService, $http, Configuration, ModalService) {
    var link = function ($scope, element, attrs) {
      element.on('click', function (event) {
        event.stopPropagation(); // keeps it from firing the click on the document
      });

      $scope.UserService = UserService;

      $scope.cssClass = attrs.cssClass ? attrs.cssClass : '';
      $scope.isProcessing = false;

      var showError = function (err, isFavourite) {
        console.log('[favourite] > error', err);
        ModalService.open(ModalService.generateConfig('default', {
          title: isFavourite ? 'Could not add to favourites' : 'Could not remove from favourites',
          // Static text only: modal bodies are compiled as templates, never interpolate the server response here (KB-8720)
          // BE 403 body: { error: 'forbidden', reason: 'not_authorized', message: 'Not authorized.' }
          body: err && err.status === 403 && err.data && err.data.reason === 'not_authorized'
            ? '<p>You can only favourite projects you are invited to or working on.</p>'
            : '<p>Something went wrong. Please try again or contact Codeable support.</p>',
          closeOnBackdrop: true,
          resolveButton: { label: 'OK', class: 'button-primary' }
        }));
      };

      $scope.updateFavourite = function (task) {
        if ($scope.isProcessing) {
          return;
        }
        $scope.isProcessing = true;

        // Flip local state only after BE confirms (KB-8719: BE now rejects non-participant tasks with 403)
        var isFavourite = !task.favoredByCurrentUser;
        var request = isFavourite
          ? $http.put(`${Configuration.apiUrl}/users/me/tasks/favourites`, { taskId: task.id })
          : $http.delete(`${Configuration.apiUrl}/users/me/tasks/favourites/${task.id}`);

        request
          .then(function () {
            task.favoredByCurrentUser = isFavourite;
            if (isFavourite) {
              SegmentAnalytics.trackTaskFavorited(task, $state.current.name);
            } else {
              SegmentAnalytics.trackTaskUnfavorited(task, $state.current.name);
            }
          })
          .catch(function (err) {
            showError(err, isFavourite);
          })
          .finally(function () {
            $scope.isProcessing = false;
          });
      };

      $scope.addText = 'Add to favourites';
      $scope.removeText = 'Remove from favourites';
    };

    return {
      restrict: 'E',
      templateUrl: require('../../views/directives/favourite.html'),
      link: link,
      scope: {
        task: '=task'
      }
    };
  }

  app.directive('favourite', ['SegmentAnalytics', '$state', 'UserService', '$http', 'Configuration', 'ModalService', favourite]);
})();
